import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../theme';

export const useQuoteChangeWarningStyles = createStyles(({ token }) => ({
  quoteChangeWarning: {
    '&&': {
      '.ant-modal-content': {
        width: '380px !important',
      },

      '.ant-modal-body': {
        width: 380,
      },

      '.ant-btn': {
        width: 'auto !important',
        marginTop: ThemeSpaces.SPACE_NORM_15,
      },
    },
  },
  content: {
    textAlign: 'center',
    fontSize: token.fontSize,
    fontFamily: ThemeFont.FONT_FAMILY4,
    fontWeight: 500,
    paddingRight: ThemeSpaces.SPACE_NORM0_5,
    paddingLeft: ThemeSpaces.SPACE_NORM0_5,
    lineHeight: 1.3,
  },
  controls: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
}));
